import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHouseRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.627 2.144a.56.56 0 0 1 .75 0l5.436 4.876a.56.56 0 0 1 .042.794.56.56 0 0 1-.794.042l-.188-.168V12.5c0 .827-.672 1.5-1.5 1.5H4.626c-.827 0-1.5-.673-1.5-1.5V7.688l-.187.168a.563.563 0 0 1-.752-.837zm.375 1.174-3.75 3.364v5.82c0 .207.17.375.376.375h1.125V10.44c0-.933.754-1.688 1.687-1.688h1.124c.933 0 1.687.755 1.687 1.688v2.437h1.125a.376.376 0 0 0 .375-.375v-5.82l-3.75-3.361zm-1.125 9.56h2.25V10.44a.56.56 0 0 0-.563-.563H7.44a.56.56 0 0 0-.563.563z" })
});
export default SvgHouseRegularIcon;
